import { Component, Input } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Step, StepsService } from 'src/app/core/steps.service';
import { Unpaid, UnpaidService } from 'src/app/core/unpaid.service';
import { ERROR_STEP_NOT_FOUND, ERROR_UNPAID_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-order-details-installments',
  templateUrl: './order-details-installments.component.html',
  styleUrls: ['./order-details-installments.component.scss'],
})
export class OrderDetailsInstallmentsComponent {
  @Input() store_id?: string | null;
  @Input() order_id?: string | null;

  is_list_steps_running = false;
  is_list_unpaids_running = false;
  steps?: Step[];
  unpaids?: Unpaid[];

  constructor(
    private steps_service: StepsService,
    private unpaids_service: UnpaidService,
    private error_service: ErrorService,
  ) {}

  ngOnInit(): void {
    this.listSteps(this.store_id as string, this.order_id as string);
    this.listUnpaids(this.order_id as string);
  }

  onRefresh(): void {
    this.listSteps(this.store_id as string, this.order_id as string);
    this.listUnpaids(this.order_id as string);
  }

  listSteps(store_id: string, order_id: string): void {
    this.is_list_steps_running = true;
    this.steps_service.listByOrder(store_id, order_id).subscribe({
      next: response => {
        this.steps = response.data;
        this.is_list_steps_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code === ERROR_STEP_NOT_FOUND) {
          this.steps = [];
        } else {
          this.error_service.processGenericApiError(error);
        }
        this.is_list_steps_running = false;
      },
    });
  }

  listUnpaids(order_id: string): void {
    this.is_list_unpaids_running = true;
    this.unpaids_service.listByOrder(order_id).subscribe({
      next: response => {
        this.unpaids = response.data;
        this.is_list_unpaids_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code === ERROR_UNPAID_NOT_FOUND) {
          this.unpaids = [];
        } else {
          this.error_service.processGenericApiError(error);
        }
        this.is_list_unpaids_running = false;
      },
    });
  }
}
